import type { SvgComponent } from '@/types/SvgComponent';

export const SpeakerXIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_1170_497)">
        <path
          d="M22.1028 9.46387C22.3225 9.2442 22.678 9.2442 22.8977 9.46387C23.1171 9.68356 23.1173 10.0392 22.8977 10.2588L21.0452 12.1113L22.8977 13.9639L22.97 14.0518C23.114 14.2701 23.0898 14.5666 22.8977 14.7588C22.7056 14.9509 22.409 14.975 22.1907 14.8311L22.1028 14.7588L20.2502 12.9062L18.3977 14.7588C18.1781 14.9784 17.8225 14.9782 17.6028 14.7588C17.3831 14.5391 17.3831 14.1835 17.6028 13.9639L19.4553 12.1113L17.6028 10.2588C17.3831 10.0391 17.3831 9.68354 17.6028 9.46387C17.8225 9.2442 18.178 9.2442 18.3977 9.46387L20.2502 11.3164L22.1028 9.46387Z"
          fill="currentColor"
        />
        <path
          d="M13.9043 2.66699C14.0739 2.53509 14.3041 2.51206 14.4971 2.60645C14.69 2.70087 14.8125 2.89655 14.8125 3.11133V21.1113C14.8124 21.3261 14.69 21.5218 14.4971 21.6162C14.3041 21.7106 14.0739 21.6875 13.9043 21.5557L7.30664 16.4238H3C2.65194 16.4238 2.3184 16.2852 2.07227 16.0391C1.82616 15.793 1.68754 15.4594 1.6875 15.1113V9.11133C1.6875 8.76327 1.82617 8.42973 2.07227 8.18359C2.31841 7.93745 2.6519 7.79883 3 7.79883H7.30664L13.9043 2.66699ZM8.06152 8.6377V15.584L13.6875 19.96V4.26172L8.06152 8.6377ZM3 8.92383C2.95027 8.92383 2.90235 8.94335 2.86719 8.97852C2.83207 9.01367 2.8125 9.06163 2.8125 9.11133V15.1113L2.82715 15.1826C2.83648 15.2052 2.84957 15.2265 2.86719 15.2441C2.90234 15.2793 2.9503 15.2988 3 15.2988H6.93652V8.92383H3Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1170_497">
          <rect width="24" height="24" fill="white" transform="translate(0 0.111084)" />
        </clipPath>
      </defs>
    </svg>
  );
};
